// We are in an initializer file, so we MUST NOT import from too many dependencies
import { ValidatePassword } from '@react/auth/helpers';
// import must be specific to avoid circular dependencies.
import { IsValidPhoneNumber } from '@react/helpers/phone_number';
import { Schema } from '@react/helpers/validation';

Schema.addMethod(Schema.string, 'phone', function format(countryCode, message) {
  return this.test('phone', message, (value, testContext) => {
    const { path, createError } = testContext;
    const isValid = !value || IsValidPhoneNumber(value, countryCode);

    if (!isValid) return createError({ path, message });
    return true;
  });
});

Schema.addMethod(Schema.string, 'password', function format(message) {
  return this.test('password', message, (value, testContext) => {
    const { path, createError } = testContext;
    const errors = ValidatePassword(value);

    if (errors.length > 0) throw createError({ path, message, params: errors });
    return true;
  });
});

// yup v1's builtin `.email()` regex is stricter (ASCII-only) than v0.x's, which also accepted
// Latin-1 characters. Some flows (e.g. sign up) intentionally let odd-but-plausible emails
// through client-side validation and rely on a backend round-trip to reject them with a
// dedicated error message. Restoring the old, permissive regex preserves that flow.
const LEGACY_EMAIL_REGEX =
  // eslint-disable-next-line no-control-regex
  /^((([a-zA-Z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\x80-\xFF])+(\.([a-zA-Z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\x80-\xFF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\x80-\xFF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\x80-\xFF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\x80-\xFF])|(([a-zA-Z]|\d|[\x80-\xFF])([a-zA-Z]|\d|-|\.|_|~|[\x80-\xFF])*([a-zA-Z]|\d|[\x80-\xFF])))\.)+(([a-zA-Z]|[\x80-\xFF])|(([a-zA-Z]|[\x80-\xFF])([a-zA-Z]|\d|-|\.|_|~|[\x80-\xFF])*([a-zA-Z]|[\x80-\xFF])))\.?$/;

Schema.addMethod(Schema.string, 'legacyEmail', function format(message) {
  return this.matches(LEGACY_EMAIL_REGEX, { message, excludeEmptyString: true });
});
